import styled, { css } from "styled-components";

export const ContainerUser = styled.div`
    display: flex;

    @media(max-width: 400px){
        flex-direction: column;
    }
`;

export const AnswerDiv = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const CommentsDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: 82%;
    overflow-y: auto;
    border-bottom: 1px solid var(--border-color);
`;

export const PaddingDiv = styled.div`
    padding-left: 1.25rem;
`;

interface ISpanComment{
    isBlue: boolean;
}

export const SpanComment = styled.span<ISpanComment>`
    font-size: 0.8rem;
    border-radius: 10px;
    padding: 5px;
    margin-bottom: 16px;
    white-space: pre-wrap;
    border: 1px solid ${(props) => props.isBlue ? "var(--blue)" : "var(--header-color)"};
    background: var(--header-color);
    color: ${(props) => props.isBlue ? "var(--blue)" : "var(--input-font-color)"};

    span.highlighted{
        background: var(--blue);
        color: #FFF;
        font-size: 0.825rem;
        padding: 0 4px;
        border-radius: 4px;
    }
`;

export const ColumnFlex = styled.div`
    display: flex; 
    flex: 1;
    flex-direction: column;
`;


export const TextAreaAnswering = css`
    margin-top: -2px;
    >textarea{ 
        border: 1px solid var(--blue) !important; 
        max-height: 64px !important;
    } 
    >label { 
        color: var(--blue) !important; 
    }
`;

export const UlUsers = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;

    overflow-y: auto;
    max-height: 138px;

    background: var(--input-background-color);
    border: 1px solid var(--border-color);

    border-radius: .25rem;
    padding: .35714rem 0;

    display: flex;
    flex-direction: column;

    button{
        border: none;
        background: transparent;

        padding: 0 .35714rem;
        font-size: 0.9rem;

        display: flex;
        align-items: center;

        min-width: 11rem;
        line-height: 1.5rem;
        transition: 300ms ease;

        >small{
            margin-left: 2px;
        }

        &.hovered, &:hover{
            background: var(--main-color);
            color: #FFF;
            cursor: pointer;
        }
    }
`;
